import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconEndsWith(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5L19 5L19 19L16 19C15.7167 19 15.4792 19.0958 15.2875 19.2875C15.0958 19.4792 15 19.7167 15 20C15 20.2833 15.0958 20.5208 15.2875 20.7125C15.4792 20.9042 15.7167 21 16 21L19 21C19.55 21 20.0208 20.8042 20.4125 20.4125C20.8042 20.0208 21 19.55 21 19L21 5C21 4.45 20.8042 3.97917 20.4125 3.5875C20.0208 3.19583 19.55 3 19 3L16 3C15.7167 3 15.4792 3.09583 15.2875 3.2875C15.0958 3.47917 15 3.71667 15 4C15 4.28333 15.0958 4.52083 15.2875 4.7125C15.4792 4.90417 15.7167 5 16 5ZM3.2929 12.7071C2.90237 12.3166 2.90237 11.6834 3.2929 11.2929L6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289C8.09763 8.68342 8.09763 9.31658 7.70711 9.7071L6.41421 11L14 11C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13L6.41421 13L7.70711 14.2929C8.09763 14.6834 8.09763 15.3166 7.70711 15.7071C7.31658 16.0976 6.68342 16.0976 6.29289 15.7071L3.2929 12.7071Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
